import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Lenis from "lenis";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { MDBContainer, MDBCard, MDBCardBody, MDBCardText, MDBCardTitle } from "mdb-react-ui-kit";
import "mdb-react-ui-kit/dist/css/mdb.min.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const testimonials = [
    {
        name: "Ravi Sharma",
        title: "Director, TechSol Pvt Ltd",
        text: "The EasyMember platform streamlined our membership process, improving efficiency and reducing manual work.",
        rating: 5,
        img: "https://mdbootstrap.com/img/new/avatars/6.jpg",
    },
    {
        name: "Anjali Verma",
        title: "Operations Head, FitLife Gym",
        text: "Managing memberships and payments became much easier with EasyMember. Highly useful for fitness centers.",
        rating: 4,
        img: "https://mdbootstrap.com/img/new/avatars/4.jpg",
    },
    {
        name: "Vikram Singh",
        title: "Founder, ProHealth Club",
        text: "Tracking member attendance and automating renewals helped us focus on business growth instead of admin work.",
        rating: 5,
        img: "https://mdbootstrap.com/img/new/avatars/1.jpg",
    },
    {
        name: "Neha Joshi",
        title: "CEO, Yoga Bliss",
        text: "With EasyMember, we reduced paperwork and improved customer engagement. A great solution for our yoga studio.",
        rating: 5,
        img: "https://mdbootstrap.com/img/new/avatars/2.jpg",
    },
];

const Testimonials = () => {
    useEffect(() => {
        const lenis = new Lenis();
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
    }, []);

    return (
        <div className="section-white">

            <MDBContainer className="py-5 lp_revenue">
                <h2 className='mb-3 text-center'>Testimonials</h2>
                <p className="text-center">
                    What customers say about Easymember
                </p>
                <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    spaceBetween={10}
                    slidesPerView={3}
                    loop={true}
                    navigation
                    pagination={true}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        768: { slidesPerView: 2 },
                        1024: { slidesPerView: 3 },
                    }}
                    className="mt-4 pt-4"
                >
                    {testimonials.map((testimonial, index) => (
                        <SwiperSlide key={index} className="mb-5 px-2">
                            <div >
                                <MDBCard className="h-100 shadow-3-strong">
                                    <MDBCardBody>
                                        <div className="d-flex align-items-center mb-3">
                                            <img src={testimonial.img} alt={testimonial.name} className="rounded-circle me-3" width="50" height="50" />
                                            <div>
                                                <MDBCardTitle className="mb-0">{testimonial.name}</MDBCardTitle>
                                                <p className="text-muted">{testimonial.title}</p>
                                            </div>
                                        </div>
                                        <MDBCardText>{testimonial.text}</MDBCardText>
                                        <div className="text-warning fs-4">{"★".repeat(testimonial.rating)}</div>
                                    </MDBCardBody>
                                </MDBCard>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </MDBContainer>
        </div>

    );
};

export default Testimonials;
